import { render, staticRenderFns } from "./BidTag.vue?vue&type=template&id=07b127be&"
import script from "./BidTag.vue?vue&type=script&lang=js&"
export * from "./BidTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports